/* ConvertMate 24-oct-2026 · Agregar al carrito compartido por cm-pdpg-main y cm-col-grilla.
   Usa /cart/add.js y, si el tema tiene cart-drawer o cart-notification (Dawn), lo abre con sus secciones.
   Si no hay ninguno, lleva a /cart. Sin JS el <form> hace POST nativo a /cart/add. */
(function () {
  if (window.cmAddToCart) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function cartEl() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  window.cmAddToCart = function (opts) {
    // opts: { id, quantity, after: 'drawer'|'cart'|'checkout', button }
    var el = cartEl();
    var body = { items: [{ id: Number(opts.id), quantity: Number(opts.quantity || 1) }] };
    var useEl = opts.after === 'drawer' && el && typeof el.renderContents === 'function' && typeof el.getSectionsToRender === 'function';
    if (useEl) {
      body.sections = el.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var btn = opts.button;
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Error');
        document.dispatchEvent(new CustomEvent('cm:cart:added', { detail: res.json }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        if (opts.after === 'checkout') { window.location.href = root + 'checkout'; return res.json; }
        if (!useEl) { window.location.href = root + 'cart'; return res.json; }
        var item = (res.json.items && res.json.items[0]) || {};
        var state = Object.assign({}, item, { sections: res.json.sections, id: item.id, key: item.key });
        if (el.classList.contains('is-empty')) el.classList.remove('is-empty');
        el.renderContents(state);
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cm-atc', productVariantId: opts.id, cartData: res.json }); } catch (e) {}
        }
        return res.json;
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
      });
  };

  // Formularios declarativos: <form data-cm-atc data-after="drawer"> con input[name=id]
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-cm-atc]');
    if (!form) return;
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-cm-atc-error]');
    if (err) err.textContent = '';
    window.cmAddToCart({
      id: id.value,
      quantity: (form.querySelector('[name="quantity"]') || {}).value || 1,
      after: form.getAttribute('data-after') || 'drawer',
      button: btn
    }).catch(function (ex) {
      if (err) err.textContent = ex.message; else form.submit();
    });
  });
})();
